import { CircleCheck } from "lucide-react"

export const GaCertificateActiveButton = ({title} : {title: string}) => {
    return (
        <div className="ga-tag ga-tag--success ga-ar-tag-lg">
            <CircleCheck size={32} className="ga-tag__icon" />
            <span className="ga-tag__label">{title}</span>
        </div>
    )
}